import React from "react";
import { FaEdit, FaTrash, FaExchangeAlt, FaFilter } from "react-icons/fa";

interface UserCardProps {
    email: string;
    role: string | undefined;
    onEdit: () => void;
    onDelete: () => void;
    onMigrateAll: () => void;
    onUpdateFilters: () => void;


}

export default function UserCard({
    email,
    role,
    onEdit,
    onDelete,
    onMigrateAll,
    onUpdateFilters
}: UserCardProps) {
    return (
        <div className="flex flex-col md:flex-row md:items-center justify-between bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 rounded-lg p-4 mb-4 shadow-md transition-shadow hover:shadow-lg">
            <div className="flex flex-col md:flex-row md:items-center gap-4">
                <div className="font-medium">{email}</div>
                <div className="text-sm text-gray-500 dark:text-gray-400">{role}</div>
            </div>
            <div className="flex gap-2 mt-2 md:mt-0">
                <button
                    onClick={onMigrateAll}
                    className="flex items-center gap-1 px-3 py-1 rounded-lg bg-blue-500 text-white hover:bg-blue-600 transition-colors"
                >
                    <FaExchangeAlt /> Migrate All
                </button>

                <button
                    onClick={onEdit}
                    className="flex items-center gap-1 px-3 py-1 rounded-lg bg-orange-500 text-white hover:bg-orange-600 transition-colors"
                >
                    <FaEdit /> Edit
                </button>
                <button
                    onClick={onUpdateFilters}
                    className="flex items-center gap-1 px-3 py-1 rounded-lg bg-yellow-500 text-white hover:bg-yellow-600 transition-colors"
                >
                    <FaFilter /> Update Filters
                </button>
                <button
                    onClick={onDelete}
                    className="flex items-center gap-1 px-3 py-1 rounded-lg bg-red-500 text-white hover:bg-red-600 transition-colors"
                >
                    <FaTrash /> Delete
                </button>
            </div>
        </div>
    );
}
